<template>
  <div>
    <el-dialog
      title="请确认员工信息"
      center
      :visible.sync="dialogVisible_add1"
      width="60%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <!-- :disabled="form.relationship === 0" -->
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input
              maxlength="50"
              clearable
              v-model="form.name"
              placeholder="请输入姓名"
              :disabled="title=='编辑'"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="identity_type">
            <el-select
              clearable
              v-model="form.identity_type"
              placeholder="请选择证件类型"
              style="width:100%;"
              :disabled="title=='编辑'"
            >
              <el-option label="身份证" :value="0"></el-option>
              <el-option label="护照" :value="1"></el-option>
              <el-option label="港澳台通行证" :value="2"></el-option>
              <el-option label="其他" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="identity_code">
            <el-input
              :disabled="title=='编辑'"
              clearable
              maxlength="30"
              v-model="form.identity_code"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="性别"
            prop="gender"
            :disabled="title=='编辑'"
          >
            <el-radio-group v-model="form.gender">
              <el-radio :label="1" disabled>男</el-radio>
              <el-radio :label="0" disabled>女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="婚姻状况" prop="marriage">
            <el-radio-group v-model="form.marriage">
              <el-radio :label="0">未婚</el-radio>
              <el-radio :label="1">已婚</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="出生日期"
            prop="birthday"
            v-if="form.identity_type !== 0 && form.identity_type !== ''"
          >
            <el-date-picker
              type="date"
              placeholder="请选择出生日期"
              v-model="form.birthday"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
              :disabled="title=='编辑'"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号码" prop="contacttel">
            <el-input clearable v-model="form.contacttel" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="phomeCode"
          >
            <el-input
              clearable
              v-model="form.phomeCode"
              placeholder="验证码"
              style="width: 250px"
            ></el-input>
            <span class="phomeCode" v-if="phomeCodeShow" @click="getCode">
                  发送验证码</span
            >
            <span class="phomeCode1" v-else> {{ counts }}s</span>
          </el-form-item>

          <el-form-item label="关系" prop="relationship" v-if="form.relationship !== 0">
            <el-radio-group v-model="form.relationship">
              <!-- <el-radio :label="0">本人</el-radio> -->
              <el-radio :label="1">配偶</el-radio>
              <el-radio :label="2">父母</el-radio>
              <el-radio :label="4">其他</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="remove" v-if="title === '编辑' && form.relationship !== 0">
        <p @click="remove">删除体检人</p>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" :loading="loading" @click="submit('form')">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
    let phoneReg = /^1[3456789]\d{9}$/;
    import axios from "axios";
    import {
        validIdCard,
        validPhone
    } from "@/utils/validate";
    import {
        addPhysical,
        editPhysical,
        deletePhysical,
        editPhysicalStaff
    } from "@/utils/api";

    export default {
        name: "",
        props: {
            dialogVisible_add: {
                type: Boolean,
                default: false,
            },
            checkPeo: {
                type: Object,
                default: false,
            },
        },
        data() {
            const validatePhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error("请输入手机号"));
                } else if (!validPhone(value)) {
                    callback(new Error("手机号格式不正确"));
                } else {
                    callback();
                }
            };
            const validateIdCard = (rule, value, callback) => {
                if (!value) {
                    callback(new Error("请输入证件号"));
                } else if (!validIdCard(value) && this.form.identity_type === 0) {
                    callback(new Error("证件号格式不正确"));
                } else {
                    callback();
                }
            };
            return {
                dialogVisible_add1: false,
                checkPeo1: {},
                loading: false,
                title: "",
                counts: '',
                phomeCodeShow: true,
                form: {
                    name: "",
                    identity_type: "",
                    identity_code: "",
                    gender: "",
                    birthday: "",
                    contacttel: "",
                    relationship: "",
                    marriage: '',
                    phomeCode: '',
                },
                rules: {
                    name: [{
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }],
                    marriage: [{
                        required: true,
                        message: "请选择婚姻状况",
                        trigger: "blur"
                    }],
                    phomeCode: [{
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }],
                    identity_type: [{
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }, ],
                    identity_code: [{
                        required: true,
                        validator: validateIdCard,
                        trigger: "blur"
                    }, ],
                    gender: [{
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }],
                    birthday: [{
                        required: true,
                        message: "请选择日期",
                        trigger: "change",
                    }, ],
                    contacttel: [{
                        required: true,
                        validator: validatePhone,
                        trigger: "blur"
                    }, ],
                    relationship: [{
                        required: true,
                        message: "请选择关系",
                        trigger: "change"
                    }, ],
                },
            };
        },
        watch: {
            dialogVisible_add: {
                handler: function(newValue, oldValue) {
                    this.dialogVisible_add1 = newValue;
                },
                deep: true,
            },
            checkPeo: {
                handler: function(newValue, oldValue) {
                    this.$nextTick(() => {
                        // this.$refs["form"].clearValidate();
                    });
                    this.checkPeo1 = newValue;
                    if (JSON.stringify(this.checkPeo1) == "{}") {
                        this.title = "添加";
                        this.form = {
                            name: "",
                            identity_type: "",
                            identity_code: "",
                            gender: "",
                            birthday: "",
                            contacttel: "",
                        };
                    } else {
                        this.title = "编辑";
                        this.form = {
                            name: this.checkPeo1.name,
                            identity_type: this.checkPeo1.identity_type,
                            identity_code: this.checkPeo1.identity_code,
                            gender: this.checkPeo1.gender,
                            birthday: this.checkPeo1.birthday,
                            contacttel: this.checkPeo1.contacttel,
                            relationship: this.checkPeo1.relationship,
                        };
                    }
                },
                deep: true,
            },
        },
        created() {},
        activated() {},
        mounted() {},
        methods: {
            cancel() {
                this.dialogVisible_add1 = false;
                this.$emit("dialogVisible-event-add", this.dialogVisible_add1);
            },
            // 删除体检人
            remove() {
                this.$confirm("是否删除该体检人?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(async() => {
                        let res = await deletePhysical(this.checkPeo1.id).then((res) => {
                            this.dialogVisible_add1 = false;
                            this.$emit("dialogVisible-event-add", this.dialogVisible_add1);
                            this.$message.success("删除成功");
                        });
                    })
                    .catch((err) => {});
            },
            //添加体检人
            async addPhysical(form) {
                let res = await addPhysical(form)
                    .then((res) => {
                        this.$emit("dialogVisible-event-add-relative", res.data.data);
                        this.loading = false;
                        this.dialogVisible_add1 = false;
                        this.$emit("dialogVisible-event-add", this.dialogVisible_add1);
                        this.$message.success("添加成功");
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            //编辑体检人（家属）
            async editPhysical(form, id) {
                let res = await editPhysical(form, id)
                    .then((res) => {
                        this.loading = false;
                        this.dialogVisible_add1 = false;
                        this.$emit("dialogVisible-event-add", this.dialogVisible_add1);
                        this.$message.success("编辑成功");
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            // 获取验证码
            getCode() {
                if (!this.form.contacttel) {
                    this.$message({
                        message: "请填写手机号",
                        type: "error",
                        center: true,
                    });
                } else if (!phoneReg.test(this.form.contacttel)) {
                    this.$message({
                        message: "请填写正确的手机号",
                        type: "error",
                        center: true,
                    });
                } else {
                    let _this = this;
                    axios
                        .post(
                            BASE_URL +
                            `/exam/relatives/update/token/`, {
                                mobile: this.form.contacttel,
                                project: JSON.parse(sessionStorage.getItem("project")).id
                            }
                        )
                        .then((res) => {
                            let TIME_COUNT = 60;
                            if (!_this.timer) {
                                _this.counts = TIME_COUNT;
                                _this.phomeCodeShow = false;
                                _this.timer = setInterval(() => {
                                    if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                                        _this.counts--;
                                    } else {
                                        _this.phomeCodeShow = true;
                                        clearInterval(_this.timer);
                                        _this.timer = null;
                                    }
                                }, 1000);
                            }
                        });
                }
            },

            //编辑体检人（员工）
            async editPhysicalStaff(form, id) {
                let res = await editPhysicalStaff(form, id)
                    .then((res) => {
                        this.loading = false;
                        this.dialogVisible_add1 = false;
                        this.$emit("dialogVisible-event-add", true);
                        this.$message.success("编辑成功");
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            //提交表单
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.post(BASE_URL + `/exam/relatives/update/mobile/`, {
                                mobile: this.form.contacttel,
                                token: this.form.phomeCode,
                                marriage: this.form.marriage,
                                project: JSON.parse(sessionStorage.getItem("project")).id

                            }).then(res => {
                                if (res.data.return_code == 0) {
                                    this.$message.success("修改成功");
                                    this.dialogVisible_add1 = false
                                }
                            })
                            // if (this.form.identity_type === 0) {
                            //     delete this.form.birthday;
                            //     delete this.form.gender;
                            // }
                            // this.loading = true;
                            // if (this.title === "添加") {
                            //     this.addPhysical(this.form);
                            // } else {
                            //     if (this.checkPeo1.relationship === 0) {
                            //         this.editPhysicalStaff(this.form, this.checkPeo1.id);
                            //     } else {
                            //         this.editPhysical(this.form, this.checkPeo1.id);
                            //     }
                            // }
                    } else {}
                });
            },
        },
        computed: {},
    };
</script>

<style scoped lang="scss">
    $primary-color: #FF000F;
    .remove {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        p {
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
            color: $primary-color;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .phomeCode {
        cursor: pointer;
        width: 92px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        display: inline-block;
        margin-left: 10px;
        color: #fff;
        background: $primary-color;
        border-radius: 4px;
        /* width: 92px;
  height: 30px;
  color: #fff;
  background: #999999;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin-left: 60px; */
    }
    
    .phomeCode1 {
        cursor: pointer;
        width: 92px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        display: inline-block;
        margin-left: 10px;
        color: #fff;
        background: #C5C5C5;
        border-radius: 4px;
        /* width: 92px;
  height: 30px;
  color: #fff;
  background: #999999;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin-left: 60px; */
    }
</style>


// WEBPACK FOOTER //
// src/components/common/handlePeople.vue